<template>
  <div class="my-10">
    <div class="px-4">
      <h1 class="text-3xl font-bold mb-6">{{ __('Users') }}</h1>
    </div>

    <div class="flex flex-col sm:flex-row justify-between px-4 items-center">
      <div class="flex flex-col sm:flex-row items-center flex-shrink-0 md:space-x-4">
        <dropdown class="md:min-w-40 md:w-auto h-10 bg-gray-500 w-full px-2" placement="bottom-end">
          <div class="flex items-center justify-between cursor-pointer select-none group">
            <div class="text-white mr-1 whitespace-nowrap truncate">
              {{ selectedStatus }}
            </div>
            <icon class="w-5 h-5 fill-current text-white" name="cheveron-down"/>
          </div>
          <div slot="dropdown" class="shadow-lg bg-gray-500 rounded-b w-40">
            <template v-for="(link, index) in dropdownLinks">
              <inertia-link :href="link.url" class="flex items-center px-2 h-10 text-white hover:bg-gray-600">
                {{ link.label }}
              </inertia-link>
            </template>
          </div>
        </dropdown>

        <div class="relative flex items-center mb-4 sm:mb-0 sm:mr-6">
          <input class="text-lg relative w-64 pl-6 pr-10 h-10 rounded-lg border border-gray-600 focus:border-coral-400 placeholder-gray-400" autocomplete="off" type="text" name="search" :placeholder="__('Search user...')" v-model="searchTerm" @keypress.enter="search">
          <div class="w-4 h-4 absolute right-0 mr-3 z-10 cursor-pointer" @click="search">
            <icon name="search" class="text-gray-600 fill-current"></icon>
          </div>
        </div>
      </div>

      <div>
        <inertia-link :href="route('users.create')" class="btn-primary">
          {{ __('Add user') }}
        </inertia-link>
      </div>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 overflow-scroll">
      <table class="w-full" v-if="users.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 w-10">{{ __('Id') }}</th>
          <th class="p-4 text-left">{{ __('Name') }}</th>
          <th class="p-4 text-left">{{ __('Email') }}</th>
          <th class="p-4 text-left">{{ __('Roles') }}</th>
          <th class="p-4 text-right w-40">{{ __('Actions') }}</th>
        </tr>

        <tr v-for="(user, index) in users.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 text-center">{{ user.id }}</td>
          <td class="p-4">
            <inertia-link :href="route('users.edit', {id: user.id})" class="text-coral-400 hover:text-gray-500 font-semibold">
              {{ user.name }}
            </inertia-link>
          </td>
          <td class="p-4">{{ user.email }}</td>
          <td class="p-4">{{ user.role_names }}</td>
          <td class="px-4 text-center">
            <div class="flex items-center w-full justify-end">
              <inertia-link :href="route('users.edit', {id: user.id})" class="list-edit-button mr-2">
                <icon name="edit" class="w-4 h-4 fill-current"></icon>
              </inertia-link>
              <inertia-link v-if="user.can_impersonate" :href="route('users.impersonate', {user: user.id})" method="post" as="button" class="px-2 py-1 bg-gray-600 text-white text-xs font-semibold rounded mr-2 hover:bg-coral-400">
                {{ __('Impersonate') }}
              </inertia-link>
              <button @click="destroy(user)" class="list-delete-button">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </div>
          </td>
        </tr>
      </table>
      <div v-else>
        {{ __('No users at the moment...') }}
      </div>
    </div>

    <pagination :links="users.meta.links"/>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Pagination from '@/Shared/Pagination';
import Icon from '@/Shared/Icon';
import _, {pickBy} from 'lodash';
import Dropdown from "../../Shared/Dropdown";

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Users'),
    };
  },
  props: {
    users: Object,
    status: String,
    term: String,
  },
  components: {
    Layout,
    Icon,
    Pagination,
    Dropdown
  },
  data() {
    return {
      searchTerm: this.term,
      dropdownLinks: [
        {url: this.route('users.index'), label: this.__("Active users")},
        {url: this.route('users.index', {status: 'inactive'}), label: this.__("Inactive users")},
        {url: this.route('users.index', {status: 'all'}), label: this.__("All users")},
      ]
    };
  },
  methods: {
    search: _.throttle(function () {
      this.$inertia.get(this.route('users.index', pickBy({'term': this.searchTerm, status: this.status})), {}, {replace: true, preserveState: true});
    }, 150),
    destroy(user) {
      if (confirm(this.__('Are you sure you want to delete :name?', {name: user.name}))) {
        this.$inertia.delete(this.route('users.destroy', {user: user.id}));
      }
    },
  },
  computed: {
    selectedStatus() {
      let statuses = {
        active: this.__("Active users"),
        all: this.__("All users"),
        inactive: this.__("Inactive users"),
      };

      return statuses[this.status ?? 'active'];
    }
  }
};
</script>
